import http from '@/utils/http';
import i18n from '@/main';

export default {
    consultar(tipo, documento) {
        return http.post({
            url: `/diagnostico-socioambiental/buscar/${tipo}/${documento}`,
            lockScreen: true,
            lockMessage: i18n.t(
                'mensagens.sistema.realizandoDiagnosticoSocioambiental'
            )
        });
    }
};
